import * as dynamicFieldsService from '../../../../../../services/api/dynamic-fields-api';
import * as taskTypesService from '../../../../../../services/api/task-types-api';

export function getDisplayNameForObjectType(objectType) {
    const objectTypeMapping = {
        [dynamicFieldsService.OBJECT_TYPES.taskComment]: 'Task Comments',
        [dynamicFieldsService.OBJECT_TYPES.taskDetail]: 'Task Detail',
    };
    
    return objectTypeMapping[objectType];
}

export async function fetchDynamicFieldsDesigner(taskTypeId, projectTypeId) {
    const dynamicFields = await dynamicFieldsService.getDynamicFieldsDesigner({ taskTypeId, projectTypeId });
    return dynamicFields.sort((a, b) => {
        if (a.Order > b.Order) {
            return 1;
        } else if (a.Order < b.Order) {
            return -1;
        } else {
            return 0;
        }
    });
}

export async function fetchDynamicFieldsMasks(taskTypeId) {
    return dynamicFieldsService.getDynamicFieldsMasks({ taskTypeId });
}

export async function fetchDynamicFieldsRegex(taskTypeId) {
    return dynamicFieldsService.getDynamicFieldsRegex({ taskTypeId });
}

export async function fetchObjectTypes() {
    const objectTypes = await dynamicFieldsService.getDynamicFieldsObjects();
    return objectTypes.map((type) => ({ type, name: getDisplayNameForObjectType(type) }));
}

export async function fetchTaskTypes() {
    const taskTypes = await taskTypesService.getTaskTypes();
    return taskTypes.map(({ Id, Type }) => ({ id: Id, name: Type }));
}

export async function saveDynamicFields(taskTypeId, projectTypeId, dynamicFields) {
    // find all ids in old fields that are not in new fields
    // to set isDeleted to true for those old fields
    const oldDynamicFields = await dynamicFieldsService.getDynamicFieldsDesigner({ taskTypeId, projectTypeId });
    const dynamicFieldsIds = dynamicFields.map((field) => field.Id);
    const dynamicFieldsToSave = dynamicFields.map((field, idx) => ({
        ...field,
        Label: field.Label ? field.Label : 'Untitled Field',
        Order: idx,
        Visible: true,
        TaskTypeId: taskTypeId,
        ProjectTypeId: projectTypeId,
        ObjectType: field.ObjectType ?? dynamicFieldsService.OBJECT_TYPES.taskComment,
    }));
    oldDynamicFields.forEach((field) => {
        const { Id } = field;
        if (Id > 0 && !dynamicFieldsIds.includes(Id)) {
            dynamicFieldsToSave.push({ ...field, Deleted: true, Visible: false });
        }
    });

    return dynamicFieldsService.saveDynamicFieldsDesigner(taskTypeId,projectTypeId, dynamicFieldsToSave);
}
